export default __webpack_public_path__ + "static/media/exams-and-surgicals-light.334d2233.svg";